module.exports = __webpack_public_path__ + "static/media/VerticalBottomAdPreview.61ec7927.svg";